import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ kicker, title, dark = true }) => (
  <div className="max-w-2xl">
    <p
      className={`font-display text-sm font-bold uppercase tracking-[0.3em] ${
        dark ? "text-[#00AEEF]" : "text-[#0077B6]"
      }`}
    >
      {kicker}
    </p>
    <h2
      className={`font-display mt-3 text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-5xl ${
        dark ? "text-[#f4f4f2]" : "text-[#111214]"
      }`}
    >
      {title}
    </h2>
  </div>
);
